import useSWRMutation from "swr/mutation";
import { LogLevel } from "../../Shared/hooks/useLogging/Logging-types";
import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
import { AUTH_SWR_KEYS } from "../Utilities/swrKeys";
import { useCachedSWR } from "../Utilities/useCachedSWR";
import { processError, updateCustomerInfo } from "./customerInfoQuery-utils";
export const useCustomerInfoQuery = () => {
    const { datadogLog } = useLogging();
    const { data, error: fetchError, isLoading, } = useCachedSWR(AUTH_SWR_KEYS.CUSTOMER_INFO, {
        onSuccess: (data) => {
            if (!data.success) {
                datadogLog("Failed to get Customer Info.", LogLevel.ERROR, undefined);
                throw new Error("Something unexpected happened while loading the Customer Info.");
            }
        },
        onError: (error) => {
            datadogLog("Failed to get Customer Info.", LogLevel.ERROR, undefined, error);
        },
    });
    const { trigger, isMutating, error: mutationError, } = useSWRMutation(AUTH_SWR_KEYS.CUSTOMER_INFO, updateCustomerInfo, {
        onError: (error) => {
            const processedError = processError(error);
            datadogLog("Failed to update Customer Info.", LogLevel.ERROR, undefined, processedError);
        },
        populateCache: true,
    });
    return { data, fetchError, mutationError, isLoading, trigger, isMutating };
};
